import config from '../../config'
import T from '../common/js/tools'
/** 
 * 获取设备ID，返回promise
 */
const getDeviceIdFromValiVersionP = () => {
    return new Promise(function (resolve) {
        var deviceid = '00000000000000000000000111111'
        resolve(deviceid)
    })
}
/** 
 * 获取用户登录信息,返回promise 
 */
const getUserInfoP = function () {
    return new Promise((resolve) => {
        resolve({
            userUuid: '6d848850-63f3-4b7c-ab0b-771ec6fc9d78',
            phone: 15625096894,
            reporterUuid: '41514819',
            userId: '1069906606745866240'
        })
    });
}

/** 
 * 原生登陆 
 */
const nativeLoginP = () => {
    return new Promise((resolve) => {
        resolve({
            userUuid: 'ff78d032-a44c-4b96-a3c8-4eb6d009f0e9',
            phone: '15625096894',
            reporterUuid: '41514819',
            userId: '123'
        })
    })
}
/**
 * @description 获取端内版本号
 * @return Promise.resolve 此处均返回resolve，不需要抓异常
 */
const getInsideVersion = () => {
    return new Promise((resolve) => {
        resolve(510)
    });
}

/** 
 * 私信
 */
const privateLetter = () => {
    return new Promise((resolve) => {
        window.console.log('你已经成功跳转私信页面了')
        resolve('假设你已经跳转到私信页面了')
    })
}

/** 
 * 获取记者订阅状态 
 * @resolve  0未订阅，1已订阅
 */
const getReporterSubStatus = () => {
    return new Promise((resolve) => {
        resolve(0)
    })
}

/** 
 * 通知原生修改订阅状态
 * @param param {Object} - 参数对象
 * @param param.reporterUuid {String | Number} - 记者uuid
 * @param param.subStatus {Number} 1 - 已订阅，0 - 未订阅 
 */
const setNativeSubStatus = (param) => {
    return new Promise((resolve) => {
        window.console.info('你已经调用了模拟通知原生修改订阅状态的方法' + JSON.stringify(param))
        resolve(true)
    })
}

/** 
 * 获取埋点请求头
 */
const getHttpHeaders = () => {
    return new Promise((resolve) => {
        resolve({
            "os": "YW5kcm9pZA\u003d\u003d",
            "latitude": "MjMuMTI4Nzkz",
            "channel": "",
            "Connection": "close",
            "screen": "MTA4MHgyMTU5",
            "deviceId": "MDAwMDAwMDAtMmUzNi1iMDI3LTAwMDAtMDAwMDJlMDBkNDc3",
            "version": "NS4wLjA\u003d",
            "operator": "5Lit5Zu955S15L+h",
            "versionCode": "NTAwMA\u003d\u003d",
            "mac": "RTQ6QTc6QzU6NzI6NDU6QjE\u003d",
            "manufacturer": "SFVBV0VJ",
            "osVersion": "Mjg\u003d",
            "bluetooth": "",
            "imei": "QTAwMDAwOEUwQTA4OA\u003d\u003d",
            "model": "RU1MLUFMMDA\u003d",
            "networkType": "V2lGaQ\u003d\u003d",
            "brand": "SFVBV0VJ",
            "androidId": "NmNmNTk2YTU4MGRlNjhhNg\u003d\u003d",
            "longitude": "MTEzLjMyMDc5MQ\u003d\u003d"
        })
    })
}

const methods = {
    getDeviceIdFromValiVersionP,
    getUserInfoP,
    nativeLoginP,
    privateLetter,
    getReporterSubStatus,
    getInsideVersion,
    setNativeSubStatus,
    getHttpHeaders
}

if (process.env.NODE_ENV === 'development' && config.isDesk) {
    T.native = Object.assign(T.native, methods)
}
export default methods